import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';

//for Authentication
import firebase from './Firebase';
import Auth from './Auth';

const loading = () => <div className="animated fadeIn pt-3 text-center"><div className="sk-spinner sk-spinner-pulse"></div></div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));
const PolicyLayout = React.lazy(() => import('./containers/PolicyLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Register = React.lazy(() => import('./views/Pages/Register'));
const PreRegister = React.lazy(() => import('./views/Pages/PreRegister'));
const PasswordReset = React.lazy(() => import('./views/Pages/PasswordReset'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/PasswordReset" name="Register Page" render={props => <PasswordReset {...props}/>} />
              <Route exact path="/pre_register" name="新規登録 - メールアドレス入力" render={props => <PreRegister {...props}/>} />
              <Route exact path="/register" name="新規登録 - 必要事項の入力" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Auth>
                <Switch>
                  <Route path="/confirmPolicy" name="CheckPolicy" render={props => <PolicyLayout {...props}/>} />
                  <Route path="/" name="Dashboard" render={props => <DefaultLayout {...props}/>} />
                  <Route render={() => <p>not found.</p>} />
                </Switch>
              </Auth>
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
